import { ChronicDiseaseSidePanelList } from './ChronicDiseaseSidePanelList';
import { ChronicDiseaseSidePanelListLoader } from './ChronicDiseaseSidePanelList.loader';

type ChronicDiseaseSidePanelContentProps = {
   readonly patientId: number;
   readonly onMedicalDataAccessAuthorizationUpdate: VoidFunction;
};

export const ChronicDiseaseSidePanelContent = (props: ChronicDiseaseSidePanelContentProps): JSX.Element => {
   return (
      <ChronicDiseaseSidePanelListLoader patientId={props.patientId}>
         {({ chronicDiseases, refetchChronicDiseases }) => (
            <ChronicDiseaseSidePanelList
               chronicDiseases={chronicDiseases}
               onMedicalDataAccessAuthorizationUpdate={() => {
                  refetchChronicDiseases();
                  props.onMedicalDataAccessAuthorizationUpdate();
               }}
            />
         )}
      </ChronicDiseaseSidePanelListLoader>
   );
};
